import { useNavigate } from 'react-router-dom';

interface MessageBubbleProps {
  role: 'user' | 'assistant';
  children: React.ReactNode;
}

const MessageBubble: React.FC<MessageBubbleProps> = ({ role, children }) => {
  const navigate = useNavigate();

  const handleArticleClick = (e: React.MouseEvent<HTMLElement>) => {
    const target = e.target as HTMLElement;
    if (target.classList.contains('article-button')) {
      const articleId = target.getAttribute('data-article-id');
      if (articleId) {
        navigate(`/library/${articleId}`);
      }
    }
  };

  return (
    <div
      className={`message-bubble message-bubble--${role}`}
      onClick={handleArticleClick}
    >
      <div className="message-bubble_content">{children}</div>
    </div>
  );
};

export default MessageBubble;
